var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16137",
    "data-name": "Group 16137",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.542,
    height: 89.766,
    viewBox: "0 0 152.542 89.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14836",
    "data-name": "Group 14836",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831",
    transform: "translate(6.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M48.008,124.2S34.734,66.473,46.019,52.65c13.274-16.258,46.187-21.805,62.211-10.235S166.7,38.6,177.41,54.626s-2.74,69.922-2.74,69.922Z",
    transform: "translate(-41.472 -36.275)",
    fill: "rgba(16,135,87,0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14832",
    "data-name": "Group 14832",
    transform: "translate(73.919 20.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M393.766,138.533c-1.976-.305-1.056-1.609-2.545-2.166-1.309-.49-3.024.053-4.323.357-2.728.639-1.84-1.085-4.278-1.525-1.978-.357-3.284,1.035-4.635,1.587-1.989.812-1.66-.745-3.855-.729a6.053,6.053,0,0,0-3.829,1.9c-1.1.961-2.3.964-4.28,1.066-1.818.094-3.529.8-.77.966,1.5.088,23.749-.082,28.676-.276,2.207-.087,3.24-.242,3.458-.853C397.677,138.047,394.942,138.715,393.766,138.533Z",
    transform: "translate(-363.803 -135.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14833",
    "data-name": "Group 14833",
    transform: "translate(0 32.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M38.974,195.756c-1.795-.257-.974-1.449-2.329-1.939-1.192-.431-2.742.078-3.917.367-2.467.607-1.68-.966-3.9-1.341-1.8-.3-2.968.972-4.187,1.485-1.8.756-1.513-.659-3.5-.622a5.49,5.49,0,0,0-3.453,1.763c-.991.882-2.079.9-3.87,1.009-1.648.1-3.192.763-.688.883,1.361.065,21.536-.312,26-.537,2-.1,2.935-.252,3.128-.808C42.516,195.276,40.043,195.909,38.974,195.756Z",
    transform: "translate(-11.813 -192.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14834",
    "data-name": "Group 14834",
    transform: "translate(120.49 28.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M614.14,173.4c-1.884-.336-1-1.776-2.423-2.39-1.248-.54-2.885.059-4.124.4-2.6.706-1.753-1.2-4.077-1.682-1.886-.393-3.135,1.144-4.423,1.753-1.9.9-1.582-.822-3.676-.8-1.692.015-2.942,1.383-3.656,2.1-1.054,1.061-2.2,1.064-4.084,1.177-1.734.1-3.367.887-.736,1.066,1.43.1,22.65-.1,27.351-.315,2.105-.1,3.09-.268,3.3-.943C617.871,172.86,615.261,173.6,614.14,173.4Z",
    transform: "translate(-585.561 -169.657)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14835",
    "data-name": "Group 14835",
    transform: "translate(11.343 8.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M96.523,78.965c-5.089.081-2.246-2.181-4.407-2.6s-3.616,1.11-5.669.308c-2.178-.851-3.2-2.355-5.911-1.793-.926.193-2.307,1.848-3.325,1.855-1.207.008-1.247-1.413-2.448-1.274-2.467.285-2.611,1.352-4.03,2.406a7.829,7.829,0,0,1-4.091,1.376c-.8-.046-1.769,1.34,1.209,1.341,5.3,0,23.023-.367,29.207-.3C97.805,80.288,99.623,78.916,96.523,78.965Z",
    transform: "translate(-65.825 -74.758)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14852",
    "data-name": "Group 14852",
    transform: "translate(73.066 61.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14848",
    "data-name": "Group 14848",
    transform: "translate(0 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8555",
    "data-name": "Path 8555",
    d: "M359.738,329.01s.286-.614.678-1.279a1.729,1.729,0,0,1,1.6-.693,2.742,2.742,0,0,1-.363,1.526A2.086,2.086,0,0,1,359.738,329.01Z",
    transform: "translate(-359.738 -327.03)",
    fill: "#677e52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14849",
    "data-name": "Group 14849",
    transform: "translate(0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8556",
    "data-name": "Path 8556",
    d: "M359.824,328.907a5.954,5.954,0,0,0,1.235-.78,3.515,3.515,0,0,0,.919-1.106h0a.065.065,0,0,1,.116.058v0a3.613,3.613,0,0,1-.987,1.106,5.99,5.99,0,0,1-1.274.74.011.011,0,0,1-.014-.005A.011.011,0,0,1,359.824,328.907Z",
    transform: "translate(-359.817 -326.984)",
    fill: "#b7ca79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14850",
    "data-name": "Group 14850",
    transform: "translate(0.416 1.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8557",
    "data-name": "Path 8557",
    d: "M361.732,332.564l.636.12a.038.038,0,0,1-.014.075h-.005l-.621-.172a.011.011,0,0,1,0-.021Z",
    transform: "translate(-361.719 -332.563)",
    fill: "#b7ca79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14851",
    "data-name": "Group 14851",
    transform: "translate(1.68 0.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8558",
    "data-name": "Path 8558",
    d: "M367.9,331.293c-.045-.276-.091-.554-.161-.823a.026.026,0,0,1,.049-.015v0c.062.277.1.554.133.833a.01.01,0,0,1-.009.012A.011.011,0,0,1,367.9,331.293Z",
    transform: "translate(-367.739 -330.438)",
    fill: "#b7ca79"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14855",
    "data-name": "Group 14855",
    transform: "translate(132.579 80.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14853",
    "data-name": "Group 14853",
    transform: "translate(3.113 0.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8559",
    "data-name": "Path 8559",
    d: "M660.82,419.657a3.428,3.428,0,0,0-1.462.505,2.682,2.682,0,0,0-1.292,3,20.506,20.506,0,0,0,1.584-2.371A4.19,4.19,0,0,1,660.82,419.657Z",
    transform: "translate(-657.953 -419.656)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14854",
    "data-name": "Group 14854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8560",
    "data-name": "Path 8560",
    d: "M643.13,417.8a3.506,3.506,0,0,1,1.062.739c1.834,2.336,1.952,5.122,1.284,6.167C645.438,422.344,643.125,417.775,643.13,417.8Z",
    transform: "translate(-643.13 -417.797)",
    fill: "#80af1b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17322",
    "data-name": "Group 17322",
    transform: "translate(-2284.206 -413.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18091",
    "data-name": "Path 18091",
    d: "M2339.185,571.633l41.875.822a4.33,4.33,0,0,1,4.251,4.186l1.894,60.526a3.193,3.193,0,0,1-3.2,3.286l-48.01-.074a3.031,3.031,0,0,1-3.032-3.085l1.2-60.855A4.916,4.916,0,0,1,2339.185,571.633Z",
    transform: "translate(0 -137.675)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18092",
    "data-name": "Path 18092",
    d: "M2366.752,1525.433h0l-5.54-.181a3.43,3.43,0,0,1-3.3-3.482l.165-8.365a.131.131,0,0,1,.13-.128h0a.131.131,0,0,1,.128.133l-.165,8.365a3.168,3.168,0,0,0,3.052,3.216l5.539.181a.13.13,0,0,1,0,.261Z",
    transform: "translate(-23.405 -1023.642)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18093",
    "data-name": "Path 18093",
    d: "M2399.444,563.2c5.677.884,25.207,3.656,41.417,2.733a1.317,1.317,0,0,1,1.394,1.269l2.03,60.74a1.515,1.515,0,0,1-1.455,1.565c-6.815.268-34.881,1.272-44.86.029a1.2,1.2,0,0,1-1.051-1.209l.882-63.739A1.424,1.424,0,0,1,2399.444,563.2Z",
    transform: "translate(-60.011 -129.745)",
    fill: "#16b26e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18094",
    "data-name": "Path 18094",
    d: "M2410.654,589.837c5.456.849,24.223,3.513,39.8,2.626a1.265,1.265,0,0,1,1.339,1.22l1.951,58.368a1.456,1.456,0,0,1-1.4,1.5c-6.55.258-33.52,1.223-43.109.028a1.153,1.153,0,0,1-1.01-1.161l.848-61.25A1.368,1.368,0,0,1,2410.654,589.837Z",
    transform: "translate(-70.621 -154.741)",
    fill: "#97ccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18095",
    "data-name": "Path 18095",
    d: "M2753.061,425.9a4.39,4.39,0,0,0-3.857-.859,1.905,1.905,0,0,0-1.393,1.977l.323,4.5,4.894.532S2756.079,428.085,2753.061,425.9Zm-2.227,3.585a1.223,1.223,0,1,1,1.246-1.2A1.223,1.223,0,0,1,2750.833,429.481Z",
    transform: "translate(-390.123)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17322-2",
    "data-name": "Group 17322",
    transform: "translate(2358.192 425.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18096",
    "data-name": "Path 18096",
    d: "M2755.722,437.991a.243.243,0,0,1-.154-.209l-.051-.717a.243.243,0,1,1,.484-.035l.051.717a.243.243,0,0,1-.33.244Zm-.1-1.406a.243.243,0,0,1-.154-.209l-.039-.545a1.945,1.945,0,0,1,1.418-2.012,3.79,3.79,0,0,1,1.854-.04.243.243,0,0,1-.107.474,3.308,3.308,0,0,0-1.618.034,1.457,1.457,0,0,0-1.062,1.509l.039.545a.243.243,0,0,1-.33.244Z",
    transform: "translate(-2755.423 -433.684)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18097",
    "data-name": "Path 18097",
    d: "M2643.855,522.171l.045-2.261a1.38,1.38,0,0,1,1.454-1.35l15.576.841a1.342,1.342,0,0,1,1.269,1.286l.087,2.175Z",
    transform: "translate(-292.578 -87.879)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18098",
    "data-name": "Path 18098",
    d: "M2726.727,529.817h0l-.67-.013a.131.131,0,0,1-.128-.133.135.135,0,0,1,.133-.128l.67.013a.13.13,0,0,1,0,.261Z",
    transform: "translate(-369.459 -98.186)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18099",
    "data-name": "Path 18099",
    d: "M2654,529.24a.243.243,0,0,1-.155-.231l.018-.915a1.407,1.407,0,0,1,1.434-1.378l2.464.049a.243.243,0,0,1-.01.486l-2.464-.049a.922.922,0,0,0-.938.9l-.018.915a.243.243,0,0,1-.331.221Z",
    transform: "translate(-301.733 -95.533)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18100",
    "data-name": "Path 18100",
    d: "M2540.913,562.106l25.733.537a1.943,1.943,0,0,1,1.843,1.71l.02.134a1.7,1.7,0,0,1-1.647,1.992l-26.4-.551a1.1,1.1,0,0,1-1.039-1.2l.08-1.25A1.421,1.421,0,0,1,2540.913,562.106Z",
    transform: "translate(-193.711 -128.737)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17327",
    "data-name": "Group 17327",
    transform: "translate(2341.505 438.117)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17323",
    "data-name": "Group 17323",
    transform: "translate(2.655 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148963",
    "data-name": "Rectangle 148963",
    width: 33.769,
    height: 1.695,
    rx: 0.847,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148964",
    "data-name": "Rectangle 148964",
    width: 33.769,
    height: 1.695,
    rx: 0.847,
    transform: "translate(0 2.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17324",
    "data-name": "Group 17324",
    transform: "translate(0 8.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18101",
    "data-name": "Path 18101",
    d: "M2498.938,817.068c0,.444-.467.782-1.043.782h-11.6c-.576,0-1.043-.338-1.043-.782h0c0-.444.467-.782,1.043-.782h11.6c.576,0,1.043.338,1.043.782Z",
    transform: "translate(-2485.248 -816.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18102",
    "data-name": "Path 18102",
    d: "M2583.389,876.119c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -871.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18103",
    "data-name": "Path 18103",
    d: "M2583.389,920.456c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -913.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18104",
    "data-name": "Path 18104",
    d: "M2583.389,966.9c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -956.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18105",
    "data-name": "Path 18105",
    d: "M2978.68,876.119a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -871.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18106",
    "data-name": "Path 18106",
    d: "M2978.68,920.456a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -913.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18107",
    "data-name": "Path 18107",
    d: "M2978.68,966.9a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -956.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18108",
    "data-name": "Path 18108",
    d: "M2794.432,1036.12a.261.261,0,0,1-.261.261h-18.645a.261.261,0,0,1-.261-.261h0a.261.261,0,0,1,.261-.261h18.645a.261.261,0,0,1,.261.261Z",
    transform: "translate(-2757.356 -1022.299)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17325",
    "data-name": "Group 17325",
    transform: "translate(0 25.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18109",
    "data-name": "Path 18109",
    d: "M2498.938,1099.979c0,.444-.467.782-1.043.782h-11.6c-.576,0-1.043-.338-1.043-.782h0c0-.444.467-.782,1.043-.782h11.6c.576,0,1.043.338,1.043.782Z",
    transform: "translate(-2485.248 -1099.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18110",
    "data-name": "Path 18110",
    d: "M2583.389,1159.029c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1154.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18111",
    "data-name": "Path 18111",
    d: "M2583.389,1203.366c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1196.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18112",
    "data-name": "Path 18112",
    d: "M2583.389,1249.814c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1239.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18113",
    "data-name": "Path 18113",
    d: "M2978.68,1159.029a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1154.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18114",
    "data-name": "Path 18114",
    d: "M2978.68,1203.366a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1196.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18115",
    "data-name": "Path 18115",
    d: "M2978.68,1249.814a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1239.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18116",
    "data-name": "Path 18116",
    d: "M2794.432,1319.03a.261.261,0,0,1-.261.261h-18.645a.261.261,0,0,1-.261-.261h0a.261.261,0,0,1,.261-.261h18.645a.261.261,0,0,1,.261.261Z",
    transform: "translate(-2757.356 -1305.209)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17326",
    "data-name": "Group 17326",
    transform: "translate(0 43.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18117",
    "data-name": "Path 18117",
    d: "M2498.938,1378.666c0,.444-.467.782-1.043.782h-11.6c-.576,0-1.043-.338-1.043-.782h0c0-.444.467-.782,1.043-.782h11.6c.576,0,1.043.338,1.043.782Z",
    transform: "translate(-2485.248 -1377.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18118",
    "data-name": "Path 18118",
    d: "M2583.389,1437.717c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1433.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18119",
    "data-name": "Path 18119",
    d: "M2583.389,1482.053c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1474.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18120",
    "data-name": "Path 18120",
    d: "M2583.389,1528.5c0,.414-.467.717-1.043.717h-11.6c-.576,0-1.043-.3-1.043-.717h0c0-.414.467-.717,1.043-.717h11.6c.576,0,1.043.3,1.043.717Z",
    transform: "translate(-2564.484 -1518.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18121",
    "data-name": "Path 18121",
    d: "M2978.68,1441.939a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1437.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18122",
    "data-name": "Path 18122",
    d: "M2978.68,1486.276a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1478.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18123",
    "data-name": "Path 18123",
    d: "M2978.68,1532.724a.717.717,0,0,1-.717.717h-3.521a.717.717,0,0,1-.717-.717h0a.717.717,0,0,1,.717-.717h3.521a.717.717,0,0,1,.717.717Z",
    transform: "translate(-2943.559 -1522.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18124",
    "data-name": "Path 18124",
    d: "M2794.432,1601.94a.261.261,0,0,1-.261.261h-18.645a.261.261,0,0,1-.261-.261h0a.261.261,0,0,1,.261-.261h18.645a.261.261,0,0,1,.261.261Z",
    transform: "translate(-2757.356 -1587.858)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17328",
    "data-name": "Group 17328",
    transform: "translate(5.301 78.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14856",
    "data-name": "Group 14856",
    transform: "translate(7.113 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8561",
    "data-name": "Path 8561",
    d: "M79.438,415.406c.46-.687.729-1.537,1.419-1.98,1-.641,2.3-.107,3.423.277a8.742,8.742,0,0,0,4.808.349,2.4,2.4,0,0,1,2.026.147,6.055,6.055,0,0,0,2.629.478c3.743-.258,6.3-4.917,10.039-4.564,2.808.266,4.655,3.3,7.42,3.86,3.188.643,5.925-2.152,8.947-3.353,7.4-2.939,15.471,3.94,23.332,2.688,4.525-.721,8.607-4.109,13.151-3.525,3.508.451,6.441,3.231,9.972,3.443,4.057.244,12.478.221,19.041-2.558,3.362-1.423,2.967,5.159,10.6,5.153,2.143,0,5.6,1.552,6.319,3.569-2.715.258-6.18-.853-8.9-.7-16.338.923-32.952,1.225-49.312,1.553-8.866.178-17.083-.181-25.951-.178-7.043,0-14.262.264-21.3.267-6.026,0-10.8-.188-16.827-.356-2.494-.07-4.073-.587-8.651-.1a1.442,1.442,0,0,1-.4-.221,1.136,1.136,0,0,1-.161-1.3,2.992,2.992,0,0,1,2.391-1.543,26.507,26.507,0,0,1,2.97-.033,3.818,3.818,0,0,0,2.721-.989A3.029,3.029,0,0,0,79.438,415.406Z",
    transform: "translate(-70.926 -409.716)",
    fill: "#4c7722"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14857",
    "data-name": "Group 14857",
    transform: "translate(57.386 4.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8562",
    "data-name": "Path 8562",
    d: "M310.317,429.912c-.025.045,1.02-.036,1.475.4.693.661,1.957,3.483,1.3,4.569C313.022,432.642,310.311,429.892,310.317,429.912Z",
    transform: "translate(-310.317 -429.911)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14858",
    "data-name": "Group 14858",
    transform: "translate(23.627 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M153.186,417.306c.031.055-1.25-.044-1.807.488-.848.81-2.4,4.266-1.59,5.6C149.873,420.65,153.193,417.282,153.186,417.306Z",
    transform: "translate(-149.562 -417.305)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14861",
    "data-name": "Group 14861",
    transform: "translate(77.79 4.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14859",
    "data-name": "Group 14859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    d: "M408.652,432.791a5.063,5.063,0,0,1-1.151-3.573C408.894,430.195,408.652,432.791,408.652,432.791Z",
    transform: "translate(-407.476 -429.218)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14860",
    "data-name": "Group 14860",
    transform: "translate(1.379 0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    d: "M416.978,430.076c.025.045-1.013-.036-1.465.4-.688.656-1.944,3.458-1.289,4.536C414.293,432.787,416.984,430.056,416.978,430.076Z",
    transform: "translate(-414.041 -430.076)",
    fill: "#80af1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14862",
    "data-name": "Group 14862",
    transform: "translate(60.541 5.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8566",
    "data-name": "Path 8566",
    d: "M327.827,433.845c.021.038-.857-.03-1.24.335-.582.556-1.645,2.927-1.091,3.84C325.555,436.139,327.832,433.828,327.827,433.845Z",
    transform: "translate(-325.342 -433.845)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14863",
    "data-name": "Group 14863",
    transform: "translate(12.381 3.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8567",
    "data-name": "Path 8567",
    d: "M96.013,427.5a2.3,2.3,0,0,1,.808.258c1.6,1.109,2.211,2.831,1.995,3.615C98.336,429.9,96.005,427.487,96.013,427.5Z",
    transform: "translate(-96.013 -427.499)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14864",
    "data-name": "Group 14864",
    transform: "translate(0 8.009)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 71.402,
    cy: 1.667,
    rx: 71.402,
    ry: 1.667,
    fill: "#774d1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.3e347138ee0910088136b2bda5019dbe.svg";
export { ForwardRef as ReactComponent };